import Vue from 'vue'
import Buefy from 'buefy'
import App from './App.vue'
import router from './router'
import store from './store'
import { getModule } from 'vuex-module-decorators'
import { Meta } from './store/meta'
import '@mdi/font/css/materialdesignicons.css';
import { RateLimitError } from './error/rate_limit_error'

Vue.config.productionTip = false

Vue.use(Buefy)

Vue.config.errorHandler = (err, vm) => {
  if (err instanceof RateLimitError) {
    vm.$buefy.toast.open({
      "message": "APIのアクセス制限を超えました。しばらく経ってから再度お試しください。",
      type: "is-danger",
      duration: 3000
    })
    return
  }
  console.error(err)
}

// initialize
getModule(Meta).loadFromStorage()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
